import React, { FC, useEffect, useState,TransitionEventHandler,useRef,memo,useMemo } from 'react'
import './noticebar.scss'

interface NoticeBarProps {
  config?: {
    list?: {
      text: string
      deeplink?: string
      normallink?: string
    }[]
  }
  clickTo: (
    type?: string,
    path1?: string,
    path2?: string,
    componentId?: string
  ) => void
  id: string
  pid: string
}

const NoticeBar: FC<NoticeBarProps> = (props) => {
  const index = useRef<number>(0)
  const NoticeBarRef= useRef<HTMLDivElement>(null)
  const list = useMemo(() => props.config?.list || [], [props.config?.list])
  const [translateY, setTranslateY] = useState(0)
  const [transitionProperty, setTransitionProperty] = useState(`transform`)
  useEffect(() => {
    let timer = null
    if (list.length > 1) {
      timer = setTimeout(() => {
        if (translateY === 0) {
          setTransitionProperty(`transform`)
        }
        index.current++
        setTranslateY(translateY - NoticeBarRef.current?.clientHeight)
      }, 2000)
    }
    return () => {
      clearTimeout(timer)
    }
  }, [translateY, list])
  const handleAnimationEnd: TransitionEventHandler = () => {
    if (index.current >= list.length) {
      setTransitionProperty(`none`)
      setTranslateY(0)
      index.current = 0
    }
  }
  const length = list?.length
  const data = length ? [...list, list[0]] : []
  return (
    <div className="by-notice-bar" ref={NoticeBarRef}>
      <img
        src="http://baleen-cdn-g.bybieyang.com//static/images/brandGame/ic_notice@2x.png"
        alt=""
      />
      <div
        className="by-notice-bar-item-wrapper"
        style={{
          transform: `translateY(${translateY}px)`,
          transition: `${transitionProperty} 0.5s`,
        }}
        onTransitionEnd={handleAnimationEnd}
      >
        {data.map((item, index) => (
          <div className="by-notice-bar-item" key={index} onClick={() => {props.clickTo('noticebar',item.deeplink,item.normallink,props.id)}}>
            <span className="text-overflow">{item.text}</span>
            {
              (item.deeplink || item.normallink) && (<img
              src="http://baleen-cdn-g.bybieyang.com//static/images/brandGame/arrow.png"
              alt=""
            />)
            }
          </div>
        ))}
      </div>
    </div>
  )
}

export default memo(NoticeBar)
